import React from 'react';
import { IconButton } from '@wix/design-system';
import { X } from '@wix/wix-ui-icons-common';
import { OWNER_HELP_LINK, EDITOR_TYPE } from '../../utils/constants';
import s from './HelpBox.scss';
import { useTranslation } from 'react-i18next';

const HelpBox = ({ shouldShowHelpBox, onClose, editorType }) => {
  const { t } = useTranslation();

  const getHelpLinkByEditorType = () =>
    editorType === EDITOR_TYPE.STUDIO
      ? t('get_feedback_header_owner_studio_help_url')
      : OWNER_HELP_LINK;

  return (
    shouldShowHelpBox && (
      <div className={s.helpBoxWrapper}>
        <IconButton
          className={s.closeButton}
          onClick={onClose}
          priority="secondary"
          skin="transparent"
          size="tiny"
        >
          <X />
        </IconButton>
        <iframe
          title="help-box-iframe"
          data-hook="help-box-iframe"
          src={getHelpLinkByEditorType()}
        />
      </div>
    )
  );
};
export default HelpBox;
